export function isNotOverStep1(val, by='lbStep') {
  const funNotOverStep1 = {
    lbStep: val => !val || val <= 1,
    Finish: val => !val
  };
  return funNotOverStep1[by] && funNotOverStep1[by](val);
}